import { useEffect, useState } from "react";
import { FaSearch, } from "react-icons/fa";
import { MdFavorite } from 'react-icons/md';
import { NavLink } from "react-router-dom";

const CharCard = ({res}) => {
    return(
        <div  className="rounded-2xl flex flex-col select-none m-2">
            <img className="rounded-xl max-w-[25%] md:max-w-[36%] z-20 ml-5 md:h-36" src={res.images.jpg.image_url} alt="" />
            <NavLink to={`/view?char=${res.mal_id}`} className="bg-gray-800 hover:bg-gray-700 relative -mt-[5rem] h-24 rounded-xl md:text-sm text-xl p-2 px-3 flex flex-col justify-center items-end">
                <div className="flex items-center gap-2">
                    <MdFavorite className="fill-red-500"/> {res.favorites}
                </div>  
                <div>
                {res.name}
                </div>

            </NavLink>
        </div>
    )
}


const CharacterList = () =>{

    const [searchTerm, setSearchTerm] = useState([]);
    const [resChar,setChar] = useState([]);

    const handleKeydown = (event) => {
        if(event.key == 'Enter'){
            searchChar(searchTerm);
        }
    }

    const searchChar = async ( char ) => {
        const response = await fetch(`https://api.jikan.moe/v4/characters?q=${char}`);
        const res = await response.json();

        setChar(res.data);
        console.log(res.data);
    }


    return (
        <div className="m-5 col-span-4">
            <div className="flex flex-col">
                <div className="bg-[#1E1F25] border-[rgb(48,54,68)] border-[0.00625rem] py-5 mb-5 flex justify-center rounded-xl items-center gap-2">
                    <div className="rounded-lg ">
                        <input type="text"
                        placeholder="Search.."
                        value={searchTerm}  
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={handleKeydown}
                        // onSubmit={()=> searchAnimes(searchTerm)}
                        className="bg-[#22242C] rounded-3xl px-3 py-2 w-64 "/>
                    </div>
                    <div className="p-3 bg-[#22242C] rounded-full" onClick={()=> searchChar(searchTerm)}>
                        <FaSearch></FaSearch>
                    </div>
                </div>
                {
                        resChar?.length > 0
                        ? (
                        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 text-white text-sm text-center font-bold leading-6 bg-stripes-fuchsia rounded-lg lg:max-h-[80vh] overflow-auto scroll-dark p-2 rounded-lg">
                        
                        {resChar.map((anime) => (
                            <CharCard res={anime} />
                            ))}
                        </div>
                        ) : 
                        (
                        <div className="flex justify-center h-screen">
                        <div className="flex justify-center items-center bg-[#1E1F25] border-[rgb(48,54,68)] border-[0.00625rem] h-16 w-64 text-center rounded-xl">
                            {
                                searchTerm == '' ?
                                (
                                        <>
                                        Input Character, what you want to search
                                        </>
                                ): (
                                        <>
                                        Loading 
                                        {
                                            
                                            resChar?.length == 0
                                            ?
                                            (
                                                <>..</>
                                            ):(
                                                <> Failed, Not Found</>
                                            )
                                        }
                                        </>
                                )
                            }</div>
                        </div>
                        )
                    }
            </div>
        </div>
    )
}


export default CharacterList;